import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "lucide-react";
import { authService } from "@/services/authService";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { isAuthenticated } = useAuthenticatedUser(true);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    const formData = new FormData(e.currentTarget);
    const email = formData.get("email") as string;

    if (!email) {
      setIsLoading(false);
      setError("Email is required");
      return;
    }

    try {
      const redirectUri = `${window.location.origin}/auth/callback`;
      const { url } = await authService.getLoginUrl({
        email,
        redirectUri,
      });
      window.location.href = url;
    } catch (err: any) {
      console.error("Failed to get login URL", err);
      setError(err?.message || "Failed to initiate login");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <Card>
          <CardHeader>
            <CardTitle className="text-center">Welcome to Guesteria</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-center text-sm text-muted-foreground mb-6">
              Sign in with your email
            </p>
            <form onSubmit={handleSubmit} className="space-y-6">
              {error && (
                <Card className="border-red-200 bg-red-50 text-red-700">
                  <CardContent className="p-3">{error}</CardContent>
                </Card>
              )}

              <div className="space-y-2">
                <label htmlFor="email" className="text-sm font-medium">
                  Email
                </label>
                {/* 3. ПРИБРАЛИ value, onChange і ref. Тільки name="email" */}
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  placeholder="john.doe@example.com"
                />
              </div>

              <Button type="submit" disabled={isLoading} className="w-full">
                {isLoading ? (
                  <span className="flex items-center gap-2">
                    <Loader className="animate-spin" />
                    Redirecting...
                  </span>
                ) : (
                  "Continue"
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;